import axios from 'axios';

export default axios.create({
    baseURL: 'https://leadingpace.pythonanywhere.com/'  //https://leadingpace.pythonanywhere.com/      http://127.0.0.1:5000/
})



///<a href='https://www.freepik.com/vectors/sport'>Sport vector created by freepik - www.freepik.com</a>